import React from 'react';
import { Icon } from './style/icons';

export default function Icons ({className}) {
    return <Icon className={className} />
}